/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const factory = function () {
  const Memoize = function (fn) {
    let memo;
    return (memo = _.memoize(function (...args) {
      this.$onSet(() => memo.cache.delete());
      return fn.apply(this, args);
    }));
  };

  return Memoize;
};

module.exports = factory;
